import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { NSErrorModule, NSGridModule, NSSkeletonModule } from '@norfolk-southern/accessns-components';

import { DialogFooterModule } from '@ruby/shared/dialogs/dialog-footer/dialog-footer.module';
import { DialogHeaderModule } from '@ruby/shared/dialogs/dialog-header/dialog-header.module';
import { GuaranteeStorageDialog } from '@ruby/shared/dialogs/guarantees/guarantee-storage/component/guarantee-storage.dialog';
import { GuaranteeStorageContainer } from '@ruby/shared/dialogs/guarantees/guarantee-storage/container/guarantee-storage.container';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';
import { PipesModule } from '@ruby/shared/pipes/pipes.module';

@NgModule({
  declarations: [GuaranteeStorageDialog, GuaranteeStorageContainer],
  imports: [
    CommonModule,
    DialogHeaderModule,
    DialogFooterModule,
    DirectivesModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatRadioModule,
    NSErrorModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatExpansionModule,
    NSGridModule,
    MatCardModule,
    NSSkeletonModule,
    MatDatepickerModule,
    MatChipsModule,
    PipesModule
  ],
  exports: [GuaranteeStorageContainer]
})
export class GuaranteeStorageDialogModule {}
